<template>
	<div class="more_detail">
		<div style="width: 100%;height: 500px;background-color: rgba(0,0,0,0.3);display: flex;justify-content: space-between;display: none;">
			<div id="container" style="width: 80%;height: 100%;background-color: white;"></div>
			<div class="rightmap" style="width: 20%;height: 100%;background-color: red;box-sizing: border-box;">
				<div style="margin-top: 2rem;">当前选择的经度为：{{this.message.lng}}</div>
				<div style="margin-top: 2rem;">当前选择的纬度为：{{this.message.lat}}</div>
			</div>
		</div>
		<span style="display: block;font-weight: bold;">分销商详情</span>
		<div class="table">
			<div class="name d-flex flex-column j-sb a-center">
				<div class="w-100 d-flex j-sb a-center">
					<span>分销商级别：</span>
					<input type="text" disabled="true" v-model="message.rank_name" placeholder="请输入分销商名称"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
				<div class="w-100 d-flex j-sb a-center">
					<span>分销商名称：</span>
					<input type="text" v-model="message.agent_name" placeholder="请输入分销商名称"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
				<div class="w-100 d-flex j-sb a-center">
					<span>所属上级：</span>
					<input type="text" disabled="true" v-model="message.up_agent_name" placeholder="请输入分销商名称"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
			</div>
			<div class="location d-flex flex-column j-sb a-center">
				<div class="top flex-1 w-100 d-flex flex-column j-sa a-center">
					<div class="w-100 d-flex j-sb a-center">
						<span>所在地区：</span>
						<div class="d-flex j-sb a-center" style="width: 27.66rem;">
							<select name="" id="" disabled
								style="width: 6.09rem;height: 1.69rem;padding: 0 0.22rem;outline: none;border: 2px solid #BBBBBB;border-radius: 4rpx;color: #BBBBBB;">
								<option :value="item.label" :label="item.value" v-for="(item,index) in contry"
									:key="index"></option>
							</select>
							<el-select name="" id="" @change="changeProvince" v-model="message.province" value-key="region_id"
								placeholder="请选择所在省份">
								<el-option :value="item" :label="item.region_name"
									v-for="(item,index) in provinceList" :key="index"></el-option>
							</el-select>
							<el-select name="" id="" @change="changeCity" v-model="message.city" placeholder="请选择所在市区" value-key="region_id">
								<el-option :value="item" :label="item.region_name"
									v-for="(item,index) in cityList" :key="index"></el-option>
							</el-select>
							<el-select name="" id="" @change="changeArea" v-model="message.district"
								placeholder="请选择所在县" value-key="region_id">
								<el-option :value="item" :label="item.region_name"
									v-for="(item,index) in areaList" :key="index"></el-option>
							</el-select>
						</div>
					</div>
					<div class="w-100 d-flex j-sb a-center">
						<span>详细地址：</span>
						<input type="text" v-model="message.stores_address" placeholder="请输入详细地址"
							style="width: 27.66rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
					</div>
				</div>
				<div class="bottom flex-1 w-100 d-flex j-sb a-center">
					<div class="left h-100 d-flex flex-column j-sa a-center">
						<div class="w-100 d-flex j-sb a-center">
							<span>经度(Y)：</span>
						</div>
						<div class="w-100 d-flex j-sb a-center">
							<span>纬度(X)：</span>
						</div>
					</div>
					<div class="right h-100 d-flex j-sb a-center" style="width: 27.66rem;">
						<div class="h-100 d-flex j-sa flex-column a-center">
							<div class="w-100 d-flex j-sb a-center">
								<input type="text" v-model="message.lng" placeholder="点击获取经纬度"
									style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
							</div>
							<div class="w-100 d-flex j-sb a-center">
								<input type="text" v-model="message.lat" placeholder="点击获取经纬度"
									style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
							</div>
						</div>
						<div class="h-100 position-relative" @click="mapClick(message.lng,message.lat)"
							style="width: 12.69rem;height: 5.69rem;background: #EEF4FF;border-radius: 6px;">
							<div class="get_location">获取经纬度</div>
						</div>
					</div>
				</div>
			</div>
			<div class="account d-flex flex-column j-sb a-center">
				<div class="w-100 d-flex j-sb a-center">
					<span>登陆名称：</span>
					<input type="text" v-model="message.user_name" placeholder="请输入登陆名称"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
				<div class="w-100 d-flex j-sb a-center">
					<span>登陆密码：</span>
					<input type="text" v-model="password" placeholder="请输入登陆密码"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
			</div>
			<div class="person_in_charge d-flex flex-column j-sb a-center">
				<div class="w-100 d-flex j-sb a-center">
					<span>负责人：</span>
					<input type="text" v-model="message.seller_name" placeholder="请输入负责人姓名"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
				<div class="w-100 d-flex j-sb a-center">
					<span>联系方式：</span>
					<input type="text" v-model="message.stores_tel" placeholder="请输入联系方式"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
				<div class="w-100 d-flex j-sb a-center">
					<span>Email：</span>
					<input type="text" v-model="message.email" placeholder="请输入邮箱"
						style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
				</div>
			</div>
			<div class="logo d-flex flex-column j-sb a-start">
				<span>录入时间：{{message.add_time | timeStamp}}</span>
				<div class="w-100 flex-1 d-flex j-sb a-center" style="margin-top: 2.38rem;">
					<div class="h-100 d-flex flex-column j-sb a-start">
						<span>门店logo:</span>
						<el-upload class="avatar-uploader" action="upload" :show-file-list="false" :on-change="getFile"
							:http-request="handleUploadFile" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="message.stores_logo" :src="message.stores_logo" class="avatar">
							<!-- <img :src="message.stores_logo" alt="" style="width: 9.38rem;height: 9.38rem;"> -->
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div class="h-100 d-flex flex-column j-sb a-start">
						<span>实景图片:</span>
						<el-upload class="avatar-uploader avatar-liveimg" action="upload" :show-file-list="false"
							:on-change="getLiveFile" :http-request="handleUploadFile" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="message.live_img" :src="message.live_img" class="avatar-liveimg">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
				</div>
			</div>
		</div>
		<footer class="d-flex j-center a-center">
			<div class="d-flex j-sb a-center" style="width: 23.09rem;">
				<div class="d-flex j-center a-center">
					<span>是否开启：</span>
					<el-switch v-model="message.is_confirm" @change="switchChange(message.is_confirm)" active-value="1"
						inactive-value="0" active-color="#1E69FF" inactive-color="#B5CBF9">
					</el-switch>
				</div>
				<div class="d-flex j-center a-center" style="width: 7.09rem;height: 1.69rem;
			border: 2px solid #000000; box-sizing: border-box; border-radius: 0.845rem;cursor: pointer;"
					@click="delDistributor">
					删除分销商</div>
				<div class="d-flex j-center a-center" style="width: 7.09rem;height: 1.69rem;
			background: #1E69FF;color: #FFFFFF;border-radius: 0.845rem;cursor: pointer;" @click="releaseDistributor">
					发布</div>
			</div>
		</footer>

	</div>
</template>

<script>
	import provinceData from '@/components/city-data/province.js';
	import cityData from '@/components/city-data/city.js';
	import areaData from '@/components/city-data/area.js';
	export default {
		data() {
			return {
				pickerValue: [0, 0, 0],
				contry: [{
					value: '中国',
					label: 'CN'
				}, ],
				provinceList: [], // 省份列表
				cityList: [], // 城市列表
				areaList: [], // 区/县列表
				options: [{
					value: '省分公司',
					label: '省分公司'
				}, {
					value: '市分公司',
					label: '市分公司'
				}, {
					value: '直营店',
					label: '直营店'
				}, {
					value: '加盟门店',
					label: '加盟门店'
				}, {
					value: '待装修门店',
					label: '待装修门店'
				}],
				is_open: true,
				login_name: '格力深圳市分公司',
				password: '',
				location: '',
				exact_address: '广东省深圳市罗湖区建明路256号',
				longitude: '5636554.326',
				latitude: '5636554.326',
				enter_date: '2021-01-06  22:14',
				logo: '',
				virtual_show: '',
				agent_id: 0,
				message: {},
				provinceId: 0,
				cityId: 0,
				areaId: 0,
				strimagebase64: '',
				liveimgbase64: '',
				mapLocal: '',
				defaultCity: '北京',
				// 地图对象
				map: null,
				// 定位默认地址 | 搜索后选择的地址
				formattedAddress: null,
				// 地址对应的经纬度信息
				position: {},
				// 检索关键字
				searchValue: '',
				// 检索函数对象
				placeSearch: null,
				// 检索结果数据数据
				searchInfoList: [],
				// 地图标记
				marker: '',
				// 地址解析（正向）
				geocoder: '',
				// 地址名称
				name: '',
				address : ''
			}
		},
		methods: {
			getProviceData() {
				this.$api.getProvince().then((res) => {
					this.provinceList = res.data
				})
			},
			getCity(cityId) {
				let param = {
					province_id: cityId
				}
				this.$api.getCity(param).then((res) => {
					this.cityList = res.data
				})
			},
			getArea(areaId) {
				let param = {
					city_id: areaId
				}
				this.$api.getArea(param).then((res) => {
					this.areaList = res.data
				})
			},
			// 获取分销商详情
			getResellerMessage() {
				let param = {
					act: 'agent_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id: this.agent_id,
				}
				this.$api.company_list(param).then((res) => {
					if (res.code == 0) {
						this.message = res.data
						this.provinceId = res.data.province_id
						this.cityId = res.data.city_id
						this.areaId = res.data.district_id
						this.getCity(this.message.province_id)
						this.getArea(this.message.city_id)
						this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
					} else {
						this.$message.error('发生错误，请重试');
					}

				}).catch((err) => {
					this.$message.error(err);
				})
			},
			changeProvince(e) {
				this.message.province = e.region_name
				this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
				this.message.province_id = e.region_id
				let param = {
					province_id: e.region_id
				}
				this.$api.getCity(param).then((res) => {
					this.cityList = res.data
					this.message.city = this.cityList[0].region_name
					this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
					this.message.city_id = this.cityList[0].region_id
					let param = {
						city_id: this.message.city_id
					}
					this.$api.getArea(param).then((res) => {
						this.areaList = res.data
						this.message.district = this.areaList[0].region_name
						this.message.district_id = this.areaList[0].region_id
						this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
					})
				})
			},
			changeCity(e) {
				this.message.city_id = e.region_id
				this.message.city = e.region_name
				this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
				let param = {
					city_id: e.region_id
				}
				this.$api.getArea(param).then((res) => {
					this.areaList = res.data
					this.message.district = this.areaList[0].region_name
					this.message.district_id = this.areaList[0].region_id
					this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
				})
			},
			changeArea(e) {
				this.message.district_id = e.region_id
				this.message.district = e.region_name
				this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
			},
			switchChange(confirmStatus) {
				this.message.is_confirm = confirmStatus
			},
			handleAvatarSuccess(res, file) {
				this.message.stores_logo = URL.createObjectURL(file.raw);
			},
			// 获取图片转base64
			getBase64(file) {
				return new Promise(function(resolve, reject) {
					const reader = new FileReader()
					let imgResult = ''
					reader.readAsDataURL(file)
					reader.onload = function() {
						imgResult = reader.result
					}
					reader.onerror = function(error) {
						reject(error)
					}
					reader.onloadend = function() {
						resolve(imgResult)
					}
				})
			},
			// 图片转base64    
			getFile(file, fileList) {
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.strimagebase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.strimagebase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.message.stores_logo = res.data
								this.$message.success('图片上传成功');
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			getLiveFile(file, fileList) {
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.liveimgbase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.liveimgbase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.message.live_img = res.data
								this.$message.success('图片上传成功');
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			handleUploadFile() {

			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			delDistributor() {
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let param = {
						act: 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids: this.agent_id,
						ctrl: 'del'
					}
					this.$api.company_list(param).then((res) => {
						if (res.code == 0) {
							this.$message.success(res.msg);
						} else {
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				})
			},
			releaseDistributor() {
				let param = {
					act: 'operation_agent',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id: this.agent_id,
					ctrl: 'edit',
					rank_id: this.message.rank_id,
					agent_name: this.message.agent_name,
					up_agent_id: this.message.up_agent_id,
					username: this.message.user_name,
					password: this.password,
					seller_name: this.message.seller_name,
					stores_tel: this.message.stores_tel,
					email: this.message.email,
					province: this.message.province_id,
					city: this.message.city_id,
					district: this.message.district_id,
					stores_address: this.message.stores_address,
					lng: this.message.lng,
					lat: this.message.lat,
					stores_logo: this.strimagebase64,
					live_img: this.liveimgbase64,
					is_confirm: this.message.is_confirm,
				}
				const loading = this.$loading({
					lock: true,
					text: '发布中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$api.editDistributors(param).then((res) => {
					loading.close()
					if (res.code == 0) {
						this.$message.success('编辑发布成功');
					} else {
						this.$message.error('编辑发布失败');
					}
				}).catch(err => {
					this.$message.error('编辑发布失败');
				})
			},
			mapClick(lng, lat) {
				this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
				this.$axios.get('https://restapi.amap.com/v3/geocode/geo?address=' + this.address + "&key=" + '230940c14da34b25391f85531b3c4067'+ "&output=" + 'JSON').then((res) => {
					let map = res.data.geocodes[0].location
					let arrmap = map.split(',')
					this.message.lng = arrmap[0]
					this.message.lat = arrmap[1]
					// 地图逆推理
					// this.$axios.get('https://restapi.amap.com/v3/geocode/regeo?location=' + map + "&key=" + '230940c14da34b25391f85531b3c4067').then(res => {
					// 	console.log(res);
					// })
				})
				// 定义点标记对象
				// this.$nextTick(() => {
				// 	this.initMap(lng, lat)
				// })
			},
			initMap(lng, lat) {
				
				this.map = new AMap.Map('container', {
				  resizeEnable: true,
				  //禁止拖动地图
				  // dragEnable: false,
				  //禁止放大地图
				  // zoomEnable:false,
				  center: [lng, lat],
				  zoom: 50
				});
				// 添加工具栏
				this.map.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.OverView'], () => {
				  // 工具条
				  const toolbar = new AMap.ToolBar();
				  // 比例尺
				  const scale = new AMap.Scale();
				  // 显示鹰眼
				  const overView = new AMap.OverView();
				  this.map.addControl(toolbar);
				  this.map.addControl(scale);
				  this.map.addControl(overView);
				});
				// 添加maker
				this.setMaker();
				// 添加鼠标点选地图选择地址
				this.addAmapGeocoder();
			},
			// 添加maker
			setMaker() {
				this.marker = new AMap.Marker();
				this.map.add(this.marker);
				// 添加解析地理位置插件
				this.map.plugin('AMap.Geocoder', () => {
					// 异步加载插件
					this.geocoder = new AMap.Geocoder({
						city: this.defaultCity, // 默认：“全国”
						radius: 1000 // 范围，默认：500
					});
				});
			},
			// 添加鼠标点选地图选择地址
			addAmapGeocoder() {
				// 添加maker
				this.setMaker();
				// 地图添加点击事件
				this.map.on('click', e => {
					const lnglat = [e.lnglat.lng, e.lnglat.lat];
					this.marker.setPosition(lnglat);
					this.geocoder.getAddress(lnglat, (status, result) => {
						if (status === 'complete' && result.regeocode) {
							const res = result.regeocode;
							const data = {
								// 地址名称
								adress: res.formattedAddress,
								// 纬度lat
								lat: lnglat[1],
								// 经度lng
								lng: lnglat[0]
							};
							this.formattedAddress = res.formattedAddress;
							this.position = data;
							this.message.lng = this.position.lng
							this.message.lat = this.position.lat
						} else {
							alert(JSON.stringify(result));
						}
					});
				});
			},
		},
		filters: {
			timeStamp: function(value) {
				if (!value) return '';
				var time = new Date(value * 1000);

				function timeAdd0(str) {
					if (str < 10) {
						str = '0' + str;
					}
					return str
				}
				var y = time.getFullYear();
				var m = time.getMonth() + 1;
				var d = time.getDate();
				var h = time.getHours();
				var mm = time.getMinutes();
				var s = time.getSeconds();
				return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) + ':' +
					timeAdd0(s);
			},
		},
		created() {
			this.agent_id = this.$route.params.id
			this.getResellerMessage()
		},
		mounted() {
			this.getProviceData()
		}
	}
</script>
<style>
	/* .el-input,.el-input--suffix{
		height: 1.69rem;
	}
	.el-input__inner{
		height: 1.69rem;
	} */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 9.38rem;
		height: 9.38rem;
		line-height: 9.38rem;
		text-align: center;
	}

	.avatar-liveimg .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 17.875rem;
		height: 9.38rem;
		line-height: 9.38rem;
		text-align: center;
	}

	.avatar {
		width: 9.38rem;
		height: 9.38rem;
		display: block;
	}

	.avatar-liveimg {
		width: 17.875rem;
		height: 9.38rem;
		display: block;
	}
</style>
<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		padding: 1.1rem 0.94rem;
		box-sizing: border-box;
	}

	/deep/ .el-input {
		width: 7.09rem;
		height: 1.69rem;
		border: 2px solid #BBBBBB;
		color: #BBBBBB;
		box-sizing: border-box;
	}

	/deep/ .el-select .el-input__inner {
		border: 0;
		width: 100%;
		height: 100%;
	}

	/deep/ .el-input__suffix {
		display: flex;
		align-items: center;
	}

	input {
		padding: 0 0.44rem;

		&::-webkit-input-placeholder {
			/* WebKit, Blink, Edge */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: #BBBBBB;
			font-size: 0.75rem;
		}
	}

	.more_detail {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 0 auto;
		padding: 0 0 3.63rem 0;

		.box {
			width: 16.88rem;
			height: 8.44rem;
			border: 2px solid #1E69FF;
			border-radius: 4px;
			font-size: 0.75rem;
			color: #1E69FF;
			font-weight: bold;
			cursor: pointer;

			&:hover {
				background: #caddff;
			}
		}

		.table {
			display: grid;
			grid-template-rows: 12.5rem 3.75rem 4.69rem 12.5rem;
			grid-template-columns: 30.01rem 42.2rem;
			gap: 0.94rem;
			font-size: 0.75rem;
			font-weight: bold;
			margin-top: 1rem;

			.name {
				@include common;
				grid-row: 1/2;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.location {
				@include common;
				grid-row: 1/3;
				grid-column: 2/3;
				padding: 1.88rem 2.25rem;

				.get_location {
					font-size: 0.75rem;
					color: #1E69FF;
					background: #FFFFFF;
					width: 5.59rem;
					height: 1.41rem;
					text-align: center;
					line-height: 1.41rem;
					border-radius: 0.705rem;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					box-shadow: 0px 7px 7px 0px rgba(30, 105, 255, 0.4);
					cursor: pointer;

					&::after {
						content: '';
						border: 5px solid transparent;
						border-top-color: #FFFFFF;
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%, 100%);
					}
				}
			}

			.account {
				@include common;
				grid-row: 2/4;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.person_in_charge {
				@include common;
				grid-row: 4/5;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.logo {
				@include common;
				grid-row: 3/5;
				grid-column: 2/3;
				padding: 1.3rem 2.25rem;
			}
		}

		footer {
			@include common;
			padding: 0 1.88rem;
			width: 100%;
			height: 3.28rem;
			margin-top: 1.31rem;
			font-size: 0.75rem;
		}
	}
</style>
